import {cssTheme} from '@yandex-delivery/blocks'
import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const head = css`
  box-shadow: ${cssTheme.shadows.bottomNormal};
  z-index: 1;
`
export const geolocationButton = {
  root: css`
    inset-block-start: ${spacing(-8)};
    position: absolute;
    inset-inline-end: 0;
    z-index: 1;
  `,
}
